import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import style from "./Input.module.css";

const FormInputCheckBox = ({
  name,
  label,
  control,
  error,
  onChange = () => void 0,
}) => {
  return (
    <Box className={style.control}>
      <FormControl error={error !== undefined}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <FormControlLabel
              label={label}
              control={
                <Checkbox
                  {...field}
                  checked={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                    onChange();
                  }}
                />
              }
            />
          )}
        />
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </Box>
  );
};

export default FormInputCheckBox;
